const overrideCategory = (category, categoryOverrides) => {
  const override = categoryOverrides?.[category.id];
  const overridenCategory = override || category;
  if (!Array.isArray(category.child)) return overridenCategory;
  return {
    ...overridenCategory,
    child: overridenCategory.child.map(c =>
      overrideCategory(c, categoryOverrides)
    ),
  };
};

export default overrideCategory;
